import { MAX_PLANNED_SERVICES } from '../lib/plan'
import type { Priority } from '../lib/types'

/** Reception's picked services, in pick order: the first is the ticket's service. */

/** Adds a service at the end, or takes it out so the rest close up. A full pick stays as it is. */
export function togglePick(picked: readonly string[], id: string, max = MAX_PLANNED_SERVICES): string[] {
  if (picked.includes(id)) return picked.filter((x) => x !== id)
  if (picked.length >= max) return [...picked]
  return [...picked, id]
}

/** The badge number: 1 for the first picked, 0 for a tile not picked. */
export const pickOrder = (picked: readonly string[], id: string): number => picked.indexOf(id) + 1

export const pickFull = (picked: readonly string[], max = MAX_PLANNED_SERVICES): boolean => picked.length >= max

/** The issue body: the first pick is the arrival, the rest its plan in order. */
export function issueBody(picked: readonly string[], priority: Priority) {
  const [serviceId = '', ...also] = picked
  return {
    serviceId,
    priority,
    source: 'reception',
    // Left off for one service, so a single ticket is sent as it always was.
    ...(also.length > 0 ? { alsoServiceIds: also } : {}),
  }
}

export type PickKey = { do: 'toggle'; index: number } | { do: 'print' } | null

/**
 * What a key does on the Reception tab: 1–9 toggle the tile with that number,
 * Enter prints what is picked. Enter on a button other than a tile is that button's.
 */
export function pickKey(key: string, picked: number, onOtherButton: boolean): PickKey {
  if (/^[1-9]$/.test(key)) return { do: 'toggle', index: Number(key) - 1 }
  if (key === 'Enter' && picked > 0 && !onOtherButton) return { do: 'print' }
  return null
}
